export default __webpack_public_path__ + "static/media/IMG_8410.dff66ab6.jpeg";